// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1VP4i","largestCol":"styles_largestCol__KU5do","smallestCol":"styles_smallestCol__1WUjF"};